'use strict';

/**
 * @ngdoc function
 * @name cloudBillingLegacyFrontend.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the cloudBillingLegacyFrontend
 */
angular.module('cloudBillingLegacyFrontend').controller('EaAddStep03Ctrl', function ($scope, $state) {
  $scope.team = $state.params.team;
  $scope.enrollment = $state.params.enrollment;
});
